<template>
  <div class="content">
    <div class="md-layout">
      <md-table v-model="users" :table-header-color="tableHeaderColor">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="First Name">{{
            item["first_name"]
          }}</md-table-cell>
          <md-table-cell md-label="Last Name">{{
            item["last_name"]
          }}</md-table-cell>
          <md-table-cell md-label="Company Name">{{
            item["Company Name"]
          }}</md-table-cell>
          <md-table-cell md-label="Address">{{
            item["address"]
          }}</md-table-cell>
          <md-table-cell md-label="Contact Number">{{
            item["contact_number_primary"]
          }}</md-table-cell>
          <md-table-cell md-label="Status">{{
            item["application_status"] | convertStatus
          }}</md-table-cell>
          <md-table-cell md-label="Actions">
            <div>
              <a v-bind:href="'/applications/' + item['id']">
                <md-button class="md-raised md-info">
                  <md-icon>account_box</md-icon>
                  View
                </md-button>
              </a>
            </div>
            <div>
              <md-button class="md-raised md-info">
                <md-icon>check</md-icon>
                Approve
              </md-button>
            </div>
            <div>
              <md-button class="md-raised md-danger">
                <md-icon>delete</md-icon>
                Decline
              </md-button>
            </div>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>
import api from "@/service/api";
import {
  BASE_URL,
  API_URL,
  BUBBLE_API_URL,
  STATUS_APPLICATION_FOR_APPROVAL,
  STATUS_APPLICATION_PENDING
} from "@/constants/";

export default {
  name: "ordered-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selected: [],
      users: []
    };
  },
  filters: {
    convertStatus: function(numericStatus) {
      if (numericStatus === STATUS_APPLICATION_FOR_APPROVAL) {
        return "For Approval";
      }
      if (numericStatus === STATUS_APPLICATION_PENDING) {
        return "Pending";
      }
      return "Approved";
    }
  },
  methods: {
    async fetchApplicants() {
      // const GET_ALL_PARTNER_APPLICATIONS =
      //   BUBBLE_API_URL + "/partnerapplication";
      const GET_ALL_PARTNER_APPLICATIONS = API_URL + "/partner/applications";
      console.log(GET_ALL_PARTNER_APPLICATIONS);
      const request = await api.get(GET_ALL_PARTNER_APPLICATIONS);
      const response = await request.json();
      console.log(response);
      if (response.success) {
        this.users = response.partners;
      }
    }
  },
  created() {
    this.fetchApplicants();
  }
};
</script>
